import React from 'react'
import styles from './styles.module.scss'
import BlogCard from '../Blog-Card'
import BlogCardList from '../Blog-Card/List'
import BlogContain from '../Blog-Card/Contain'
import Media from '../Media'
import { LinkWrapperWithChildItems } from '../LinkWrapper'
import { RecentPostsFields } from './types'
import { addQueryParamsToUrl } from '../../util/imageUrlUtil'
import clsx from 'clsx'
import getRandomGuid from '../../util/getRandomGuid'
import playButtonSvg from './assets/playButton.svg'
import { usePageType } from '../../util/usePageType'
import { PageTypes } from '../../constants/page-type'

const RecentPosts = ({
  title,
  cards,
  showReadTime,
  seeMoreLink,
  seeMoreText,
  styleOverride,
  blogCardStyleOverride,
  hideCardDescription,
  hideCardTag,
}: RecentPostsFields) => {
  
  const pageType = usePageType()
  const renderH2Element = pageType !== PageTypes.BLOG_PAGE
  const HeadingElement = renderH2Element ? 'h2' : 'div'
  const PlayButton = () => <img src={playButtonSvg} alt="Play button" />

  const desktopSeeMore = seeMoreLink && seeMoreText && (
    <div className={styles.linkPosition}>
      <LinkWrapperWithChildItems href={seeMoreLink} className={styles.moreLink}>
        {seeMoreText}
        <PlayButton />
      </LinkWrapperWithChildItems>
    </div>
  )


  return (
    <BlogContain
      testId="RecentPosts"
      block
      className={clsx('Bloghome-RecentPosts', styleOverride?.wrapper ?? '')}
    >
      <div className={styles.headingWrap}>
        {React.createElement(HeadingElement, {
          className: clsx(styles.head, styleOverride?.titleHead ?? '', !renderH2Element ? 'h2' : '')
        }, title)}
        {desktopSeeMore}
      </div>

      <BlogCardList
        testId="RecentPosts-Cards"
        styleOverride={{ list: styleOverride?.postList }}
      >
        {cards.map((card) => {
          let readTime = card.readTime
          if (!showReadTime) {
            readTime = undefined
          }
          return (
            <BlogCard
              styleOverride={blogCardStyleOverride}
              key={card.title + getRandomGuid()}
              image={card.image && addQueryParamsToUrl(card.image, `mh=190`)}
              imageAlt={card.imageAlt}
              imageWidth={390}
              imageHeight={190}
              title={card.title}
              href={card.href}
              tag={''}
              readTime={readTime}
            >
              {!hideCardDescription && card.description ? card.description : ''}
            </BlogCard>
          )
        })}
      </BlogCardList>
    </BlogContain>
  )
}

export default RecentPosts
